





















import { Component, Vue } from "vue-property-decorator";
import VersionBackModule from "@/store/modules/VersionBack-module";
import { UtilsString } from "@/utils/utils-string";
import { LocalStorageService } from "@/shared/services/LocalStorageConfig-service";
import usuarioModule from "@/store/modules/usuario-module";
import { RouterNames } from "@/router/routernames";
import router from "@/router/router";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
@Component({
  components: { DashGeneral: () => import("@/views/home/DashGeneral.vue") },
})
export default class Home extends Vue {
  public dialogNewVersion: boolean = false;
  public height = (25 * this.$vuetify.breakpoint.height) / 100;
  public cards = [
    {
      text: "Escanear",
      icon: "fal fa-barcode",
      descripcion: "",
      metodo: () => {
        router.push({
          name: RouterNames.escanear,
        });
      },
    },
  ];

  public created() {
    usuarioModule.getmiusuario();
  }

  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }

  public mounted() {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
      appLoading.style.display = "none";
    }
  }

  public goto(name: string) {
    this.$router.push({ name: name });
  }
}
